'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'alien';
var width = 448;
var height = 512;
var aliases = [128125];
var unicode = 'f8f5';
var svgPathData = 'M224 16c-114.9 0-208 93.1-208 208 0 81.1 51.8 149.1 106.7 198.1 27.2 24.3 54.4 43.2 74.9 56.2 10.2 6.5 18.7 11.4 24.6 14.6l1.8 1 1.8-1c5.9-3.3 14.4-8.2 24.6-14.6 20.5-12.9 47.7-31.9 74.9-56.2 54.9-49 106.7-117 106.7-198.1 0-114.9-93.1-208-208-208zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 176-224 288-224 288S0 400 0 224zm368 0l-32 0c-44.2 0-80 35.8-80 80l32 0c44.2 0 80-35.8 80-80zm-32-16l48 0 0 16c0 53-43 96-96 96l-48 0 0-16c0-53 43-96 96-96zM112 224l-32 0c0 44.2 35.8 80 80 80l32 0c0-44.2-35.8-80-80-80zm96 80l0 16-48 0c-53 0-96-43-96-96l0-16 48 0c53 0 96 43 96 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlien = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;